import React, { useState } from 'react';
import styled from '@emotion/styled';
import logo from './logo.jpg';

const Container = styled.div`
  max-width: 600px;
  margin: 0 auto;
  padding: 2rem;
  text-align: center;
`;

const Logo = styled.img`
  max-width: 200px;
  margin-bottom: 2rem;
`;

const Form = styled.form`
  display: flex;
  flex-direction: column;
  gap: 1rem;
`;

const Input = styled.input`
  padding: 0.8rem;
  border: 1px solid #ddd;
  border-radius: 4px;
  font-size: 1rem;
`;

const Button = styled.button`
  padding: 0.8rem;
  background-color: #007bff;
  color: white;
  border: none;
  border-radius: 4px;
  font-size: 1rem;
  cursor: pointer;
  transition: background-color 0.2s;

  &:hover {
    background-color: #0056b3;
  }
`;

const Message = styled.div`
  margin-top: 1rem;
  padding: 0.8rem;
  border-radius: 4px;
  color: ${props => props.error ? '#dc3545' : '#28a745'};
  background-color: ${props => props.error ? '#f8d7da' : '#d4edda'};
`;

function App() {
  const [formData, setFormData] = useState({
    firstName: '',
    email: ''
  });
  const [message, setMessage] = useState(null);
  const [error, setError] = useState(null);

  const handleSubmit = async (e) => {
    e.preventDefault();
    try {
      const response = await fetch(`${process.env.REACT_APP_API_URL}/api/subscribe`, {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json',
        },
        body: JSON.stringify(formData),
      });
      
      const data = await response.json();
      
      if (data.success) {
        setMessage('Thank you for subscribing to our newsletter!');
        setError(null);
        setFormData({ firstName: '', email: '' });
      } else {
        setError(data.error || 'Something went wrong. Please try again.');
        setMessage(null);
      }
    } catch (err) {
      setError('Unable to connect to the server. Please try again later.');
      setMessage(null);
    }
  };

  const handleChange = (e) => {
    setFormData({
      ...formData,
      [e.target.name]: e.target.value
    });
  };

  return (
    <Container>
      <Logo src={logo} alt="BordTek Logo" />
      <h1>Subscribe to Our Newsletter</h1>
      <Form onSubmit={handleSubmit}>
        <Input
          type="text"
          name="firstName"
          placeholder="First Name"
          value={formData.firstName}
          onChange={handleChange}
          required
        />
        <Input
          type="email"
          name="email"
          placeholder="Email Address"
          value={formData.email}
          onChange={handleChange}
          required
        />
        <Button type="submit">Subscribe</Button>
      </Form>
      {message && <Message>{message}</Message>}
      {error && <Message error>{error}</Message>}
    </Container>
  );
}

export default App;
